<div *ngIf="loading" class="loading-box">
  <mat-spinner diameter="32"></mat-spinner>
  <span>{{ description }}</span>
</div>
